export enum MapActionTypeEnum {
  newRegion = "newRegion",
  moveToRegion = "moveToRegion",
  unassign = "unAssign",
  changeService = "changeServiceTime",
  sendNotification = "sendNotification",
}

export const mapActionTypeEnumValues = Object.values(MapActionTypeEnum);
export const mapActionTypeEnumLabelMap: Record<MapActionTypeEnum, string> = {
  [MapActionTypeEnum.newRegion]: "Add to New Region",
  [MapActionTypeEnum.moveToRegion]: "Move to Region",
  [MapActionTypeEnum.unassign]: "Unassign from Region",
  [MapActionTypeEnum.changeService]: "Change Service Time",
  [MapActionTypeEnum.sendNotification]: "Send Notification",
};
